import React, { useState, useEffect, useRef } from 'react';
import { useSnackbar } from 'notistack';
import { Box, Divider, CircularProgress, Typography } from '@mui/material';
import { useFormik } from 'formik';
import { firstDayofYear, lastDayofYear } from '../../utils/calcDatetime';
import * as yup from 'yup';
import dayjs from 'dayjs';
import * as xlsx from 'xlsx';
import * as projectApi from '../../lib/api/project';
import { SearchBox } from '../../components/forecaststat/SearchBox';

import { prjHeaders } from '../../utils/forecastStaticData';
import ForecastStateTable from '../../components/forecaststat/ForecastStateTable';

const ForecastStatContainer = () => {
  const tableRef = useRef();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [searchStrtDt, setSearchStrtDt] = useState(firstDayofYear);
  const [searchEndDt, setSearchEndDt] = useState(lastDayofYear);

  const handleDownExcel = () => {
    const el = tableRef;
    const name = '부서별 통계';
    htmlToExcel(el.current, name);
  };

  const htmlToExcel = (tableEl, name) => {
    const wb = xlsx.utils.table_to_book(tableEl, {
      sheet: 'sheet1',
      raw: true,
    });
    xlsx.writeFile(wb, name + '.xlsx');
  };

  useEffect(() => {
    searchList(formik.values);
  }, []);

  const searchList = async (values) => {
    setLoading(true);
    const startDate =
      values.searchStrtDt !== null && values.searchStrtDt !== ''
        ? dayjs(values.searchStrtDt).format('YYYY-MM-DD')
        : '';
    const endDate =
      values.searchEndDt !== null && values.searchEndDt !== ''
        ? dayjs(values.searchEndDt).format('YYYY-MM-DD')
        : '';

    let searchData = {
      strtDt: startDate,
      endDt: endDate,
    };

    setSearchStrtDt(values.searchStrtDt);
    setSearchEndDt(values.searchEndDt);

    //try~catch async
    // const tempData = makeDataForecast();
    // setData(tempData);
    //api
    try {
      const res = await projectApi.getProjectsSummary(searchData);
      if (res.data) {
        setData(res.data.list);
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }

    setLoading(false);
  };

  const initialValues = {
    searchStrtDt: searchStrtDt,
    searchEndDt: searchEndDt,
  };

  const validationSchema = yup.object({
    searchStrtDt: yup.date().nullable().default(undefined),
    searchEndDt: yup
      .date()
      .min(yup.ref('searchStrtDt'), '검색 종료일을 확인하세요')
      .when('searchStrtDt', (searchStrtDt, schema) => {
        if (searchStrtDt) return schema.required('검색 종료일을 입력하세요');
      })
      .nullable()
      .default(undefined),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);

      setTimeout(() => {
        searchList(values);
        setSubmitting(false);
      }, 1000);
    },
  });

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', my: 1 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <SearchBox formik={formik} handleDownExcel={handleDownExcel} />
      </Box>
      <Divider sx={{ my: 1 }} />

      <Box
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        {loading ? (
          <Box sx={{ display: 'flex' }}>
            <CircularProgress />
          </Box>
        ) : Array.isArray(data) && data.length === 0 ? (
          <Box>
            <Typography variant="subtitle2">데이터가 없습니다.</Typography>
          </Box>
        ) : (
          <ForecastStateTable
            headerRows={prjHeaders}
            tableRef={tableRef}
            data={data}
          />
        )}
      </Box>
    </Box>
  );
};

export default ForecastStatContainer;
